module.exports = __webpack_public_path__ + "static/media/dog-gone-square-logo-light-bg.5548154c.png";